/* ============================================================
   Pro-Tec 2-in-1 Landing — shared behavior
   Loaded (deferred) by every Pro-Tec section; guarded so it
   only initializes once no matter how many sections include it.
   Theme-editor safe: re-initializes on shopify:section:load.
   ============================================================ */
(function () {
  if (window.__protecLanding) return;
  window.__protecLanding = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- click-to-play YouTube embeds (event delegation) ---------- */
  function playScreen(shell) {
    if (!shell || shell.dataset.loaded || !shell.dataset.yt) return;
    shell.dataset.loaded = '1';
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube.com/embed/' + encodeURIComponent(shell.dataset.yt) + '?autoplay=1&rel=0&modestbranding=1';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen = true;
    f.title = shell.getAttribute('aria-label') || 'Video';
    shell.innerHTML = '';
    shell.appendChild(f);
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var shell = e.target.closest('.protec .screen[data-yt]');
    if (shell) playScreen(shell);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (!e.target.closest) return;
    var shell = e.target.closest('.protec .screen[data-yt]');
    if (shell) { e.preventDefault(); playScreen(shell); }
  });

  /* ---------- one-shot reveals ---------- */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
  }

  /* ---------- count-up stats ---------- */
  function countUp(el) {
    if (reduced) return;
    var target = parseFloat(el.dataset.count);
    if (isNaN(target)) return;
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var small = el.querySelector('small');
    var smallHTML = small ? small.outerHTML : '';
    var t0 = null, dur = 1200;
    function frame(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      p = 1 - Math.pow(1 - p, 3);
      el.innerHTML = prefix + Math.round(target * p) + suffix + smallHTML;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  var cio = null;
  if ('IntersectionObserver' in window) {
    cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { countUp(en.target); cio.unobserve(en.target); }
      });
    }, { threshold: 0.6 });
  }

  /* ---------- story: sticky media crossfade ---------- */
  function initStory(sec) {
    if (sec.dataset.storyBound) return;
    sec.dataset.storyBound = '1';
    var steps = sec.querySelectorAll('.st-step');
    var frameImgs = sec.querySelectorAll('.story-frame img');
    var capEl = sec.querySelector('.story-cap');
    if (!steps.length) return;
    if ('IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var idx = parseInt(en.target.dataset.media, 10);
            steps.forEach(function (s) { s.classList.toggle('active', s === en.target); });
            frameImgs.forEach(function (img, i) { img.classList.toggle('active', i === idx); });
            if (capEl && en.target.dataset.caption) capEl.textContent = en.target.dataset.caption;
          }
        });
      }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
      steps.forEach(function (s) { sio.observe(s); });
    }
    steps[0].classList.add('active');
  }

  /* ---------- buy box gallery ---------- */
  function initGallery(box) {
    if (box.dataset.galleryBound) return;
    box.dataset.galleryBound = '1';
    var main = box.querySelector('.buy-main img');
    if (!main) return;
    box.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.thumb') : null;
      if (!t || !box.contains(t) || !t.dataset.img) return;
      main.src = t.dataset.img;
      box.querySelectorAll('.thumb').forEach(function (x) { x.classList.toggle('active', x === t); });
    });
  }

  /* ---------- sticky buy bar ---------- */
  function initSticky(bar) {
    if (bar.dataset.stickyBound) return;
    bar.dataset.stickyBound = '1';
    function onScroll() {
      var hero = document.querySelector('.protec.hero');
      var threshold = 600;
      if (hero) {
        var rect = hero.getBoundingClientRect();
        var heroTop = rect.top + window.scrollY;
        threshold = heroTop + hero.offsetHeight * 0.85;
      }
      var past = window.scrollY > threshold;
      var buy = document.querySelector('[data-protec-buy]');
      var overBuy = false;
      if (buy) {
        var r = buy.getBoundingClientRect();
        overBuy = r.top < window.innerHeight && r.bottom > 0;
      }
      var show = past && !overBuy;
      bar.classList.toggle('show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- init (idempotent, scoped) ---------- */
  function initScope(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.protec .rv').forEach(function (el) {
      if (el.dataset.rvBound) return;
      el.dataset.rvBound = '1';
      if (!io || reduced) return; /* stays visible without JS/IO */
      el.classList.add('rv-armed');
      io.observe(el);
    });
    root.querySelectorAll('.protec [data-count]').forEach(function (el) {
      if (el.dataset.countBound) return;
      el.dataset.countBound = '1';
      if (cio && !reduced) cio.observe(el);
    });
    root.querySelectorAll('[data-protec-story]').forEach(initStory);
    root.querySelectorAll('[data-protec-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-protec-sticky]').forEach(initSticky);
  }

  function boot() { initScope(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initScope(e.target); });
})();
